import React, { useRef, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Typography,
  Input,
  Button,
  Checkbox,
  Slider,
} from "antd";
import { imagePlaceholder } from "../../assets";
import Loader from "../../components/loader/loader";
import { GreenNotify, RedNotify, uploadMediaToS3 } from "../../helper/helper";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import { useNavigate } from "react-router-dom";
import AutoComplete from "react-google-autocomplete";

const NotifiyAlluser = () => {
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [descriptiontxt, setDescription] = useState("");
  const [content, setContent] = useState([]);
  const [restricted, setRestricted] = useState(false);
  const [coordinates, setCoordinates] = useState([-11.779889, 8.46055]);
  const [radius, setRadius] = useState(4);
  const inputRef = useRef(null);
  const fileInputImageRef = useRef(null);
  const googleAPIKey = "AIzaSyDIpm6qlncXP5fVBDmmTovsA_mMJTXzjxM";
  const disabled = title.length == 0 || descriptiontxt.length == 0;

  const notifiyUser = () => {
    let data = {
      title: title,
      text: descriptiontxt,
      restrictedArea: !restricted,
      restrictedRadius: radius,
      image: content?.[0]?.link,
      location: {
        type: "Point",
        coordinates,
        address: "",
        description: "",
      },
    };

    let getRes = (res) => {
      if (res.status === 201 || res.status === 200) {
        GreenNotify(res.message);
        navigate("/");
      } else {
        RedNotify(res.message);
      }
    };

    callApi(
      "POST",
      routes.notifyAllUser,
      data,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  const onChange = (e) => {
    setRestricted(e.target.checked);
  };

  const onChangeComplete = (value) => {
    setRadius(value);
  };

  const tooltipFormatter = (value) => `${value} Km`;

  const handlePlaceSelected = (place) => {
    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setCoordinates([lng, lat]);
    }
  };

  const pickImageFile = () => {
    fileInputImageRef.current.click();
  };

  const onImageChange = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;

    setIsLoading(true);
    try {
      // uploadMediaToS3 expects single or multiple files, here single file
      const url = await uploadMediaToS3(files[0], false);
      uploadImage(url);
    } catch (error) {
      RedNotify("Image upload failed.");
      console.error("Image upload error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const uploadImage = (url) => {
    const imageContent = {
      link: url,
      type: "image",
    };
    setContent([imageContent]);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />

      <Breadcrumb
        separator=">"
        className="bread-crumb"
        items={[
          {
            title: "Home",
          },
          {
            title: "Notify",
          },
        ]}
      />

      <h1 style={{ marginTop: "2rem", marginBottom: "2rem" }}>Notification</h1>

      <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
        <Checkbox className="custom-checkbox" onChange={onChange}>
          For All User
        </Checkbox>
      </div>

      {!restricted && (
        <>
          <AutoComplete
            style={{ width: "350px", padding: "5px", fontSize: "14px" }}
            ref={inputRef}
            apiKey={googleAPIKey}
            onPlaceSelected={handlePlaceSelected}
            options={{ types: ["geocode", "establishment"] }}
            defaultValue="Sierra Leone"
          />

          <Typography.Title level={5} style={{ marginTop: "2rem" }}>
            Select Radius Range
          </Typography.Title>

          <Slider
            style={{ width: "35rem" }}
            defaultValue={4}
            onChangeComplete={onChangeComplete}
            tooltip={{ formatter: tooltipFormatter }}
            max={300}
            min={4}
          />
        </>
      )}

      <Row gutter={216}>
        <Col span={8}>
          <Typography.Title level={5} style={{ marginTop: "2rem" }}>
            Title
          </Typography.Title>
          <Input
            style={{ marginTop: "1rem", height: "5rem" }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Notification"
          />
        </Col>
      </Row>
      <Row gutter={216}>
        <Col span={8}>
          <Typography.Title level={5} style={{ marginTop: "2rem" }}>
            Description
          </Typography.Title>
          <Input
            style={{ marginTop: "1rem", height: "5rem" }}
            value={descriptiontxt}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Notification"
          />
        </Col>
      </Row>

      <Typography.Title level={5} style={{ marginTop: "2rem" }}>
        Image (Optional)
      </Typography.Title>

      <div className="image-upload-container">
        <img
          onClick={pickImageFile}
          alt="image"
          src={
            typeof content[0]?.link === "string" && content[0]?.link
              ? content[0].link
              : imagePlaceholder
          }
        />
        <input
          type="file"
          ref={fileInputImageRef}
          accept="image/*"
          style={{ display: "none" }}
          onChange={onImageChange}
        />
      </div>

      <Button
        disabled={disabled}
        type="primary"
        style={{ marginTop: "2rem" }}
        onClick={notifiyUser}
      >
        Send
      </Button>
    </div>
  );
};

export default NotifiyAlluser;
